/**
 * @file register注册调用端能力
 * @author yanyiting@baidu.com
 */

import invoke, {invokeAsync} from './invoke';
import versionCompare from '@baidu/xbox/version_compare';
import {NOT_IN_APP, COMMAND_NOT_EXIST} from './const';
import {getOSName} from '@baidu/xbox/os';

/**
 * 端能力调起命令，返回Promise
 * @param {Object} range - 端能力anroid、ios适应范围
 * @param {Object} parameters - 端能力参数
 * @param {Object} other - 其他参数
 * @param {Object} other.appVersion - app当前版本
 * @param {Object} other.jsBridge - 与客户端约定的jsBridge取值
 * @param {Object} other.inBox - 是否在app内
 * @param {Object} other.isAsync - 是否是同步调起（默认为false）
 * @return {Promise}
 *
 * eg:
 * range: {
 *     android: {
 *         versionRange: '3.9'
 *     },
 *     ios: {
 *         versionRange: '3.9'
 *     }
 * }
 * parameters: {
 *     module: 'user',
 *     action: 'collect',
 *     params: {
 *         id: '1022731'
 *     }
 * }
 * other: {
 *     appVersion: '1.0.0',
 *     jsBridge: 'fcJsBridge',
 *     inBox: true
 *     isAsync: false
 * }
 */

export default function register(range, {
    module,
    action,
    params = {},
    callback
}, {
    appVersion,
    jsBridge,
    inBox,
    isAsync = false
}) {
    if (!inBox) {
        return isAsync ? '' : Promise.reject(NOT_IN_APP);
    }

    const osname = getOSName();
    const option = range[osname];
    // 必须要有 versionRange
    if (option && option.versionRange) {
        const version = appVersion;
        let versionRange = option.versionRange;
        if (typeof versionRange === 'string') {
            // 支持 '1.0-2.0'写法
            versionRange = versionRange.split('-');
        }
        const [startV, endV] = versionRange;
        if (versionCompare(version, startV) >= 0 && (!endV || versionCompare(version, endV) <= 0)) {
            return (isAsync
                ? invokeAsync({module, action, params, callback}, {jsBridge, inBox})
                : invoke({module, action, params}, {jsBridge, inBox})
            );
        }
    }
    return isAsync ? '' : Promise.reject(COMMAND_NOT_EXIST);
}
